/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { jsx as _jsx } from "react/jsx-runtime";
const DataFormContext = createContext({
  fields: []
});
export function DataFormProvider({
  fields,
  children
}) {
  return /*#__PURE__*/_jsx(DataFormContext.Provider, {
    value: {
      fields
    },
    children: children
  });
}
export default DataFormContext;
//# sourceMappingURL=index.js.map